const makeInitialState = () => {
  return {
    rejectionReason: ""
  };
};

export default makeInitialState;
